export const DEVIATION_BAND_COLOR = '#718096';

const MIN_POINTS_FOR_RESIDUAL_STANDARD_DEVIATION = 3;

export function residualStandardDeviation(points, equation) {
  if (!Array.isArray(points) || !Array.isArray(equation) || equation.length < 2) {
    return null;
  }

  const slope = equation[0];
  const intercept = equation[1];
  if (!Number.isFinite(slope) || !Number.isFinite(intercept)) {
    return null;
  }

  const fittedPoints = points.filter(
    (point) => Array.isArray(point) && point[0] > 0 && point[1] > 0
  );
  if (fittedPoints.length < MIN_POINTS_FOR_RESIDUAL_STANDARD_DEVIATION) {
    return null;
  }

  const residualSumOfSquares = fittedPoints.reduce((sum, [x, y]) => {
    const residual = y - (slope * x + intercept);
    return sum + residual * residual;
  }, 0);

  return Math.sqrt(
    residualSumOfSquares / (fittedPoints.length - 2)
  );
}

export function buildLinearDeviationBandSeries(sourcePoints, regressionData) {
  if (!regressionData?.points?.length) {
    return null;
  }

  const standardDeviation = residualStandardDeviation(
    sourcePoints,
    regressionData.equation
  );
  if (standardDeviation == null) {
    return null;
  }

  const above = [];
  const below = [];
  regressionData.points.forEach(([x, y]) => {
    above.push([x, y + standardDeviation]);
    below.push([x, y - standardDeviation]);
  });

  return [
    {
      name: '1 SD Above',
      data: above,
      type: 'line',
      color: DEVIATION_BAND_COLOR,
    },
    {
      name: '1 SD Below',
      data: below,
      type: 'line',
      color: DEVIATION_BAND_COLOR,
    },
  ];
}
